<template>
  <div style="margin-left:auto;margin-right:auto;margin-top:40px;margin-bottom:40px">
    <p style="text-align:center;color:#7a7157">See online portfolios of the world's leading illustrators 
      <a style="color:#7a7157;text-decoration:underline" href="https://www.illustrationx.com/">here</a>.
    </p>
    <div style="width:590px;background-color:#ffffff;margin-left:auto;margin-right:auto;border:1px solid #000000;margin-top:50px;box-shadow:0 0 12px rgba(0,0,0,0.3)">
      <div style="padding:35px 26px 35px 34px;text-align:center">
        <div style="font-size:26px;color:#7a7157;margin-bottom:40px;letter-spacing:3px;">
          THE DAY HAS DAWNED . . .
        </div>
        <img :src="$assetUrl('big-x-shadow.png')" />
        <div style="font-size:41px;margin:20px 0">
          Illustration is becoming
        </div>
        <div>
          <img :src="$assetUrl('launch-logo.png')" />
        </div>
        <div style="text-align:left">
          <div style="font-size:28px;margin:30px 0">
            We've added an <span style='color:#ce0e2d;font-weight:700'>X</span> to our name to stand for that unique and important 
            extra edge that we bring we all bring to our clients' projects.
          </div>
          <div style="border-top:1px solid #7a7157">&nbsp;</div>
          <div style="font-size:22px;margin:10px 9">
            Hello,
          </div>
          <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:10px;color:#ce0e2d;letter-spacing:0.5px">
            • LAUNCHING A NEW BRAND AND A NEW WEBSITE
          </div>
          <div style="font-size:22px;margin:10px 0;line-height:29px">
            With great e<span style='color:#ce0e2d;font-weight:500'>X</span>citement, we can now announce that from today we are 
            both Illustration<span style='color:#ce0e2d;font-weight:500'>X</span> and 
            Animation<span style='color:#ce0e2d;font-weight:500'>X</span>!
            <div style="height:12px"></div>
            We're launching our new brand and new website to help us grow the volume, value and quality of 
            commissions that we deliver to you. It's about making it clearer to potential and existing 
            clients that our artists and our agents are the best in the world. 
          </div>
          <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:5px;color:#ce0e2d;letter-spacing:0.5px">
            • ADDING AN X IDENTIFIES OUR DIFFERENCE
          </div>
          <div style="font-size:22px;margin:10px 0;line-height:29px">
            It's one small letter that stands for everything that makes us different from our competitors. 
            <div style="height:12px"></div>
            With a new strapline and messaging we've made clear that the volume of artists reflects our global coverage 
            and explained how connecting clients to a greater variety can unlock extra potential from every commission. 
            <div style="height:12px"></div>
            Research also showed that because we shared the name 'Illustration' with the medium, many clients  found our name 
            confusing, often referring to us as 'illustrationweb' from the old URL. This sounded both unattractive and out 
            of date so we needed to act. 
            <div style="height:12px"></div>
            Also, the growing importance of animation provided  the opportunity to build a distinct sister brand so 
            that we can promote animation more directly while enabling illustration and animation artists to work 
            together given that many work in both.
          </div>
          <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:10px;color:#ce0e2d;letter-spacing:0.5px">
            • A MASSIVE, MULTIDISCIPLINARY PROJECT
          </div>
          <div style="font-size:22px;margin:10px 0;line-height:29px">
            It's been over 18 months since a review of our social media programme prompted us to reconsider 
            our brand as a whole. From defining the brand, to designing and building the new brand elements 
            and website, this has been a massive project drawing on expertise from within and without the team. 
            <div style="height:12px"></div>
            Alexander Ashworth of Manifest has masterminded the brand and design phases, with tireless support 
            provided by our in-house team led by Victoria.
          </div>
          <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:10px;color:#ce0e2d;">
            • A SMART, TECHNOLOGICALLY ADVANCED WEBSITE
          </div>
          <div style="font-size:22px;margin:10px 0;line-height:29px">
            Alex has designed a website that beautifully bridges IllustrationX and AnimationX as one. A more 
            sophisticated user experience enables commissioners to easily find the perfect artists for their 
            commissions. Some canny user personalisation features effortlessly present clients with the most 
            relevant work to their needs, increasing the likelihood of a commission.
            <div style="height:12px"></div>
            David Mold has not just built the website; he has pioneered great advances in our technology. 
            Site content is propagated around the world on local servers to give users everywhere the 
            same instant, enjoyable experience. This is a Google loving thing which (along with our 
            ongoing search optimisation that generates 70% of new enquiries) is designed to make us the 
            first choice for new and existing clients.          
          </div>
          <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:10px;color:#ce0e2d;letter-spacing:0.5px">
            • CHECK OUT YOUR NEW PORTFOLIO
          </div>
          <div style="font-size:22px;margin:10px 0;line-height:29px">
            We hope you like our new look, tone and feel, and recognise how it communicates the values and promise that we all 
            stand for as agents and artists.
            <div style="height:12px"></div>
            You'll see that your portfolio has been enhanced in the new design. The agents have reviewed every single portfolio and 
            we believe all is as it should be, however if you spot anything awry please drop a line to your 
            buddy agent or <a href="mailto:Jac@illustrationX.com" style="color:#0071bc;text-decoration:none">Jac@illustrationX.com</a> . . . yes all our emails change today as well.          
          </div>
          <div style="margin-top:30px;margin-bottom:20px">
            <table border="0" cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td>
                  <img :src="$assetUrl('small-illus.png')" alt="IllustrationX logo" />
                  <div style="font-size:22px"><a href="https://www.illustrationx.com/" style="color:#ce0e2d;text-decoration:none">www.illustrationx.com</a></div>
                </td>
                <td> &nbsp;&nbsp; </td>
                <td>
                  <img :src="$assetUrl('small-anim.png')" alt="AnimationX logo" />
                  <div style="font-size:22px"><a href="https://www.animationx.com/" style="color:#ce0e2d;text-decoration:none">www.animationx.com</a></div>
                </td>
              </tr>
            </table>
          </div>
          <div style="font-size:23px;margin-top:30px">
            With best wishes,
          </div>
          <div>
            <img :src="$assetUrl('harry-sig.png')" />
          </div>
          <div style="font-size:22px;font-weight:500">
            Harry Lyon Smith
          </div>
          <div style="font-size:20px;color:#a67c52">
            Director
          </div>
          <div style="font-size:22px;margin-top:20px;margin-bottom:20px">
            <div style="margin-bottom:5px"><span style="color:#ce0e2d">T</span> 020 7720 5202</div>
            <div><a href="mailto:harry@illustrationx.com" style="color:#ce0e2d;text-decoration:none">harry@illustrationx.com</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>